import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueKeyColumnHeaderText: {
		id: 'issue-archival-archives.archives-table.head.issue-key-column-header-text',
		defaultMessage: 'Key',
		description: 'Column header for the key column in the archives table',
	},
	issueTypeColumnHeaderText: {
		id: 'issue-archival-archives.archives-table.head.issue-type-column-header-text',
		defaultMessage: 'Type',
		description: 'Column header for the type column in the archives table',
	},
	summaryColumnHeaderText: {
		id: 'issue-archival-archives.archives-table.head.summary-column-header-text',
		defaultMessage: 'Summary',
		description: 'Column header for the summary column in the archives table',
	},
	reporterColumnHeaderText: {
		id: 'issue-archival-archives.archives-table.head.reporter-column-header-text',
		defaultMessage: 'Reporter',
		description: 'Column header for the reporter column in the archives table',
	},
	archivedByColumnHeaderText: {
		id: 'issue-archival-archives.archives-table.head.archived-by-column-header-text',
		defaultMessage: 'Archived by',
		description: 'Column header for the archived-by column in the archives table',
	},
	archivedDateColumnHeaderText: {
		id: 'issue-archival-archives.archives-table.head.archived-date-column-header-text',
		defaultMessage: 'Date archived',
		description: 'Column header for the archived date column in the archives table',
	},
	selectAllCheckboxLabelText: {
		id: 'issue-archival-archives.archives-table.head.select-cell.select-all-checkbox-label-text',
		defaultMessage: 'Select all archived issues',
		description: 'Label text for select all checkbox in archives table',
	},
});
